import { createReducer, on } from '@ngrx/store';
import { CampaignsActions, RouterActions } from '@actions/index'
import { BasicReviewRequestCampaignInfo, ReviewRequestCampaignModel } from '@models/index'
import { emptyReviewRequestCampaignModel } from 'src/app/core/utilities/data-utils';

export interface State {
  reviewRequestCampaigns: ReviewRequestCampaignModel[];
  selectedReviewRequestCampaign: ReviewRequestCampaignModel;
  saveSuccess: boolean;
  addSuccess: boolean;
  sendSmstest: boolean;
  error: string;
  locationCampaignsBasicInfo: BasicReviewRequestCampaignInfo[];
  campaignsBasicInfoReports: BasicReviewRequestCampaignInfo[];
  isChangePreferredCampaig: boolean
}

const initialState: State = {
  reviewRequestCampaigns: [],
  selectedReviewRequestCampaign: emptyReviewRequestCampaignModel(),
  saveSuccess: false,
  sendSmstest: true,
  error: "",
  locationCampaignsBasicInfo: [],
  campaignsBasicInfoReports: [],
  addSuccess: false,
  isChangePreferredCampaig: false
};

export const reducer = createReducer(
  initialState,
  on(CampaignsActions.searchReviewRequestCampaignsSuccess, (state, { data }) => ({ ...state, reviewRequestCampaigns: data, selectedReviewRequestCampaign: data.length == 1 ? data[0] : state.selectedReviewRequestCampaign })),
  on(CampaignsActions.searchReviewRequestCampaignSuccess, (state, { data }) => ({ ...state, reviewRequestCampaigns: [...state.reviewRequestCampaigns.filter(campaign => campaign.id !== data.id), data], selectedReviewRequestCampaign: data })),
  on(CampaignsActions.sendSmsContentTestSuccess, (state, { sendSmsTest }) => ({ ...state, sendSmsTest })),
  on(CampaignsActions.saveReviewRequestCampaignSuccess,
    (state, { reviewRequestCampaign }) => ({
      ...state, reviewRequestCampaigns: state.reviewRequestCampaigns.find((campaign) =>
        campaign.id == reviewRequestCampaign.id)
        ? state.reviewRequestCampaigns.map((campaign) =>
          campaign.id == reviewRequestCampaign.id
            ? reviewRequestCampaign
            : campaign)
        : [...state.reviewRequestCampaigns, reviewRequestCampaign],
      selectedReviewRequestCampaign: reviewRequestCampaign,
      saveSuccess: true
    })),
  on(CampaignsActions.deleteCampaignSuccess, (state, { campaignId }) => ({
    ...state,
    reviewRequestCampaigns: state.reviewRequestCampaigns.filter(campaign => campaign.id !== campaignId),
    locationCampaignsBasicInfo: state.locationCampaignsBasicInfo.filter(campaign => campaign.id !== campaignId),
    selectedReviewRequestCampaign: state.reviewRequestCampaigns.filter(campaign => campaign.id !== campaignId).length == 1 ? state.reviewRequestCampaigns[0] : state.selectedReviewRequestCampaign
  })),
  on(CampaignsActions.setSelectedReviewRequestCampaign, (state, { reviewRequestCampaign }) => ({ ...state, selectedReviewRequestCampaign: reviewRequestCampaign })),

  on(CampaignsActions.setCampaignStateSuccess, (state, { campaignId, campaignState, editionState }) => ({
    ...state,
    selectedReviewRequestCampaign: {
      ...state.selectedReviewRequestCampaign,
      state: campaignState,
      editionState: editionState
    }
  })),

  on(CampaignsActions.setSaveSuccesCampaign, (state, { save }) => ({ ...state, saveSuccess: save })),
  on(CampaignsActions.campaingError, (state, { error }) => ({ ...state, error })),
  on(CampaignsActions.setSelectedCampaign, (state, { campaign }) => ({ ...state, selectedReviewRequestCampaign: campaign })),
  on(RouterActions.navigateAuth, () => ({ ...initialState })),
  on(CampaignsActions.getLocationCampaignsBasicInfo, (state,) => ({ ...state, locationCampaignsBasicInfo: [] })),
  on(CampaignsActions.getLocationCampaignsBasicInfoSuccess, (state, { campaignsInfo }) => ({ ...state, locationCampaignsBasicInfo: campaignsInfo })),
  on(CampaignsActions.getLocationCampaignsBasicInfoReports, (state,) => ({ ...state, campaignsBasicInfoReports: [] })),
  on(CampaignsActions.getLocationCampaignsBasicInfoReportsSuccess, (state, { campaignsInfo }) => ({ ...state, campaignsBasicInfoReports: campaignsInfo })),
  on(CampaignsActions.addCampaign, (state) => ({ ...state, addSuccess: false })),
  on(CampaignsActions.setAddCampaign, (state, { status }) => ({ ...state, addSuccess: status })),
  on(CampaignsActions.addCampaignSuccess, (state, { data }) => ({
    ...state,
    reviewRequestCampaigns: [...state.reviewRequestCampaigns, data],
    selectedReviewRequestCampaign: data,
    addSuccess: true
  })),
  on(CampaignsActions.changeLocationPreferredCampaign, (state) => ({ ...state, isChangePreferredCampaig: false })),
  on(CampaignsActions.changeLocationPreferredCampaignSuccess, (state) => ({ ...state, isChangePreferredCampaig: true })),

);


export const getReviewRequestCampaigns = (state: State) => state.reviewRequestCampaigns;
export const getSelectedReviewRequestCampaign = (state: State) => state.selectedReviewRequestCampaign;
export const getSaveSuccess = (state: State) => state.saveSuccess;
export const getError = (state: State) => state.error;
export const getLocationCampaignsBasicInfo = (state: State) => state.locationCampaignsBasicInfo;
export const getcampaignsBasicInfoReports = (state: State) => state.campaignsBasicInfoReports;
export const getAddSuccess = (state: State) => state.addSuccess;
export const isChangePreferredCampaig = (state: State) => state.isChangePreferredCampaig;
